var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.minimize)?_c('b-link',{on:{"click":function($event){return _vm.setMinimize()}}},[_c('b-icon',{attrs:{"icon":"arrows-collapse","title":"Minimizar","animation":"throb"}})],1):_c('b-link',{on:{"click":function($event){return _vm.setMaximize()}}},[_c('b-icon',{attrs:{"icon":"arrows-expand","title":"Maximizar","animation":"throb"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }